module.exports = __webpack_public_path__ + "img/logo.ad635042.png";